import { Plane } from "lucide-react";
import { Card, Section } from "../Layout";
import { useI18n } from "../i18n";

export default function Travel() {
  const { t, get } = useI18n();
  const hotels = get("travel.hotels") || [];

  return (
    <Section id="travel" eyebrow={t("travel.eyebrow")} title={t("travel.title")} icon={Plane}>
      <div className="grid md:grid-cols-3 gap-4">
        <Card className="p-6">
          <h3 className="font-serif text-2xl">{t("travel.flights_title")}</h3>
          <p className="mt-3 text-sm text-theme-text-muted">{t("travel.flights_text")}</p>
        </Card>

        <Card className="p-6">
          <h3 className="font-serif text-2xl">{t("travel.transport_title")}</h3>
          <p className="mt-3 text-sm text-theme-text-muted">{t("travel.transport_text")}</p>
        </Card>

        <Card className="p-6">
          <h3 className="font-serif text-2xl">{t("travel.hotels_title")}</h3>
          <ul className="mt-3 text-sm text-theme-text-muted list-disc pl-5 space-y-2">
            {hotels.map((hotel) => (
              <li key={hotel}>{hotel}</li>
            ))}
          </ul>
        </Card>
      </div>
    </Section>
  );
}
